import { axiosService } from './axiosService';

const auth = () => axiosService.setAuth(true);

const unwrap = async (req: Promise<any>) => {
  try {
    const { data } = await req;
    return { ok: true, data: data?.data ?? data, raw: data };
  } catch (error: any) {
    const message =
      (error?.response?.data?.message) || error?.message || 'Request failed';
    return { ok: false, error: message };
  }
};

export const liveTutorService = {
  list: (search: string, page = 1, limit = 24) =>
    unwrap(auth().get(`user/admin/live-tutors?search=${encodeURIComponent(search || '')}&page=${page}&limit=${limit}`)),
};
